export type ContentType =
  | "articleheader"
  | "audiotrack"
  | "biography"
  | "collection"
  | "externallink"
  | "infographic"
  | "interactivevideolink"
  | "LEGACY_ARTICLE"
  | "lessonspark"
  | "poll"
  | "standard"
  | "textset"
  | "video"
  | "worksheet"
  | "ARTICLE"
  | "INTERACTIVE_VIDEO"
  | "GENERATION_GENIUS_VIDEO";

const getContentLabel = (props: {
  content_type: ContentType;
  label: string;
}): string => {
  const contentLabelMap = {
    articleheader: "Article",
    audiotrack: "Audio",
    biography: "Biography",
    collection: "Collection",
    externallink: props?.label,
    infographic: "Infographic",
    interactivevideolink: "Interactive Video",
    LEGACY_ARTICLE: "Article",
    lessonspark: "Lesson Spark",
    poll: "Poll",
    standard: "Standard",
    textset: props?.label || "Text Set",
    video: "Video",
    worksheet: "Worksheet",
    ARTICLE: "Article",
    INTERACTIVE_VIDEO: "Video",
    GENERATION_GENIUS_VIDEO: "Video",
  };

  return contentLabelMap[props?.content_type];
};

export default getContentLabel;
